
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustedBy from "@/components/TrustedBy";
import IndustryChallenges from "@/components/IndustryChallenges";
import ProcurementComparison from "@/components/ProcurementComparison";
import { BenefitsMarqueeSection } from "@/components/BenefitsMarqueeSection";


import Industries from "@/components/Industries";
import IndustryVoices from "@/components/IndustryVoices";
import OurWorkflow from "@/components/OurWorkflow";
import Technologies from "@/components/Technologies";
import Tools from "@/components/Tools";
import TrainingPartnership from "@/components/TrainingPartnership";


import Footer from "@/components/Footer";
import { scrollToElement } from "@/utils/scrollUtils";
import WebSiteSchema from "@/components/schemas/WebSiteSchema";
import SEO from "@/components/SEO";
import HomeFAQ from "@/components/HomeFAQ";


const Index = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      setTimeout(() => {
        scrollToElement(id);
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <SEO
        title="Klexu | Performance-Based Models for the Machine Economy"
        description="Klexu helps procurement and supply leaders move from cost-plus contracts to performance-based models that tie supplier payment to measurable outputs and outcomes."
        path="/"
      />
      <WebSiteSchema />
      <Navbar />

      <main>
        <Hero />
        <TrustedBy />
        <IndustryChallenges />
        <Industries />
        <ProcurementComparison />
        <OurWorkflow />
        <BenefitsMarqueeSection />
        <IndustryVoices />
        

        
        
        
        <HomeFAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
